import { Component } from '@angular/core';

@Component({
  selector: 'payment-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
})
export class SessionTimeoutComponent {
  constructor() {}
}
